import React from 'react';

import { Box, Link, Text } from '@betterment/samba-react';

import IntegrationConnectButton from './IntegrationCard/IntegrationConnectButton';

import { OutboundIntegration, OutboundIntegrationType } from '../../graphql/schema';

const IntegrationConnectModalFooter: React.FC<{ integration: OutboundIntegration; saveHandler: () => void }> = ({
  integration,
  saveHandler,
}) => {
  const shouldShowLearnMoreLink: boolean = integration.learnMoreUrl != null;
  const is401k = integration.integrationType === OutboundIntegrationType.Advised_401KCustodialFeed;

  return (
    <>
      {shouldShowLearnMoreLink && (
        <Box
          css={{
            pt: 'space.300',
          }}
        >
          <Text color="text" variant="text100">
            {/* @ts-expect-error TS2322 violates strict null checks */}
            <Link href={integration.learnMoreUrl} target="_blank">
              Click here
            </Link>{' '}
            to learn more about connecting with {integration.name}
          </Text>
        </Box>
      )}
      <Box
        css={{
          mt: 'space.100',
          mb: 'space.300',
          lineHeight: 'lineHeight.25',
        }}
      >
        <Text color="text.weak" variant="text25">
          After establishing a connection, it may take up to one business day for your partner account to receive data
          from Betterment.
        </Text>
      </Box>
      {is401k && (
        <Text color="text" variant="text100">
          For 401(k) integrations, advisors on each plan will be required to confirm consent from the plan’s manager(s)
          to share the plan’s data with the integration partner.
        </Text>
      )}
      <Box
        css={{
          display: 'flex',
          justifyContent: 'left',
        }}
      >
        <IntegrationConnectButton saveHandler={saveHandler} integration={integration} />
      </Box>
    </>
  );
};

export default IntegrationConnectModalFooter;
